import { Calendar, Check, DollarSign, Edit, Trash2 } from 'lucide-react';
import type { Pago } from '../../types';

interface Props {
  pago: Pago;
  vencido: boolean;
  onEditar: (pago: Pago) => void;
  onMarcarRealizado: (pago: Pago) => void;
}

function formatearMonto(monto: number): string {
  return monto.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
}

export function TarjetaPago({ pago, vencido, onEditar, onMarcarRealizado }: Props) {
  return (
    <div
      className={`bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow border-l-4 ${
        vencido ? 'border-red-500' : 'border-emerald-500'
      }`}
    >
      <div className="flex justify-between items-start flex-wrap gap-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2 flex-wrap">
            <h3 className="text-xl font-bold text-gray-800">{pago.destinatario}</h3>
            {vencido && (
              <span className="bg-red-100 text-red-700 text-xs px-2 py-1 rounded-full">
                Vencido
              </span>
            )}
          </div>
          <div className="space-y-2 text-gray-600">
            <p className="flex items-center gap-2 text-2xl font-bold text-emerald-700">
              <DollarSign size={22} className="text-emerald-600" />
              {formatearMonto(pago.monto)}
            </p>
            <p className="flex items-center gap-2">
              <Calendar size={18} className={vencido ? 'text-red-600' : 'text-emerald-600'} />
              {new Date(pago.fechaLimite + 'T00:00:00').toLocaleDateString('es-MX', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}
            </p>
          </div>

          <div className="flex gap-2 mt-4 flex-wrap">
            <button
              onClick={() => onMarcarRealizado(pago)}
              className="bg-emerald-500 hover:bg-emerald-600 text-white px-4 py-2 rounded-lg text-sm flex items-center gap-2 transition-colors"
            >
              <Check size={16} />
              Marcar realizado
            </button>
          </div>
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => onEditar(pago)}
            className="text-blue-600 hover:text-blue-800 p-2 hover:bg-blue-50 rounded-lg transition-colors"
            title="Editar"
          >
            <Edit size={20} />
          </button>
          <button
            onClick={() => onMarcarRealizado(pago)}
            className="text-red-500 hover:text-red-700 p-2 hover:bg-red-50 rounded-lg transition-colors"
            title="Marcar realizado (se borra de la lista)"
          >
            <Trash2 size={20} />
          </button>
        </div>
      </div>
    </div>
  );
}
